/**
 * 考核报表
 */

// 公共方法
import { setStoreApiDate } from '../utils'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 获取考核报表分页列表
    async fetchGetMonthReportPage({ commit, getters }, params) {
      const { getMonthReportPage } = getters.getHttps
      const { data } = await getMonthReportPage(params)
      return setStoreApiDate(data, commit)
    },

    // 保存/更新考核报表
    async fetchUpdateMonthReport({ commit, getters }, params) {
      const { updateMonthReport } = getters.getHttps
      const { data } = await updateMonthReport(params)
      return setStoreApiDate(data, commit)
    },

    // 导出考核报表
    async fetchExportMonthReport({ commit, getters }, params) {
      const { exportMonthReport } = getters.getHttps
      const { data } = await exportMonthReport(params)
      return setStoreApiDate(data, commit)
    },

    // 模板下载
    async fetchDownloadMonthReportTemplate({ commit, getters }, params) {
      const { downloadMonthReportTemplate } = getters.getHttps
      const { data } = await downloadMonthReportTemplate(params)
      return setStoreApiDate(data, commit)
    },

    // 导入考核报表
    async fetchImportMonthReport({ commit, getters }, params) {
      const { importMonthReport } = getters.getHttps
      const { data } = await importMonthReport(params)
      return setStoreApiDate(data, commit)
    }
  }
}
